<template>
	<!-- 首页公告组件 -->
	<div class="mask">
		<div class="card_mainbox" v-if="ary.length > 0">
			<!-- 标题 -->
			<div class="top_title">
				<p><span class="iconfont icon-gonggao"> </span> 最新公告</p>
				<div class="close_login" @click="hideCard"><span></span></div>
			</div>
			<!-- 内容 -->
			<div class="card_content">
				<el-tabs type="border-card" tab-position="left" class="card_main" v-model="selectTabs">
					<el-tab-pane v-for="(item, index) in ary" :key="index" :label="item.Title" :name="item.name">
						<div class="card_infobox">
							<div class="titlebox">
								<p class="title1 diandian" v-html="item.Title"></p>
								<p class="title2 diandian">{{ item.ModifyTime }}</p>
							</div>
							<div class="content_main" v-html="item.SnContent"></div>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		panelShow: {
			type: Boolean,
		},
		ary: {
			type: Array,
		},
		selectNav: {
			type: String,
		},
	},
	watch: {
		selectNav(val) {
			this.selectTabs = this.selectNav;
		},
	},
	data() {
		return {
			selectTabs: "",
		};
	},
	methods: {
		hideCard() {
			this.$emit("hiddenDiv");
		},
	},
	created() {
		this.selectTabs = this.selectNav;
	},
};
</script>
<style>
.mask {
	width: 100%;
	height: 100%;
	position: fixed;
	z-index: 1200;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.3);
	overflow: hidden;
}

.card_mainbox {
	width: 940px;
	height: 568px;
	position: absolute;
	border-radius: 8px;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto;
}

.top_title {
	background-color: #1483d1;
	height: 45px;
	line-height: 45px;
	border-radius: 10px 10px 0 0;
	color: white;
	padding-left: 20px;
	font-size: 16px;
	position: relative;
}

.top_title::after {
	content: "";
	position: absolute;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	/* background-image: url("~@/static/img/login/newlogin/hightLightBg.webp"); */
	background-size: contain;
	width: 524px;
	height: 51px;
}

.top_title > span {
	position: absolute;
	top: 0;
	right: 0;
	width: 40px;
	height: 40px;
	text-align: center;
	z-index: 1;
	cursor: pointer;
}

.card_mainbox .card_content {
	border-radius: 0 0 9px 9px;
	background: #ffff;
	width: 100%;
	overflow: hidden;
}

.card_mainbox .card_content .el-tabs__nav-scroll {
	overflow-y: auto !important;
}

.card_mainbox .card_content .card_main {
	height: 518px;
}

/* element-ui 内置样式修改*/
.el-tabs__header {
	line-height: 25px;
}

.card_mainbox .card_content .card_main .el-tabs__item {
	line-height: 50px;
	text-align: center !important;
	width: 224px;
	height: 50px;
	color: #232924;
	border-bottom: 1px dashed #c4c4c5;
}

.card_mainbox .card_content .card_main .el-tabs__item:hover {
	color: #d86556 !important;
	background-color: #fff !important;
}

.card_mainbox .card_content .el-tabs--left .el-tabs__header.is-left {
	margin-right: 0;
	background-color: white !important;
}

.mask .el-tabs__nav .is-active {
	color: #0e78c7 !important;
}

.mask .el-tabs__nav .is-active:hover {
	color: #0e78c7 !important;
}

.card_mainbox .card_content .el-tabs--left.el-tabs--border-card .el-tabs__item.is-left {
	border: 1px solid #e6e6e6;
	width: 224px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.mask .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active,
.mask .el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
	background-color: #0e78c7;
	border-radius: 0;
	color: #0e78c7 !important;
}

.card_mainbox .card_content .el-tabs__nav {
	height: 100%;
}

.mask .el-tabs--border-card > .el-tabs__content {
	padding: 0;
	width: 700px;
	box-shadow: -3px 0 6px -1px #dcdcdc;
}

.card_mainbox .card_content .titlebox {
	/*border-bottom:1px dashed #c4c4c5;*/
	text-align: center;
	padding: 22px 0 5px;
	line-height: 22px;
}

.card_mainbox .card_content .titlebox .title1 {
	font-size: 22px;
	color: #000000;
}

.card_mainbox .card_content .titlebox .title2 {
	margin-top: 10px;
	font-size: 14px;
	color: #868686;
}

.card_mainbox .card_content .content_main {
	padding: 25px;
	font-size: 14px;
	color: #707070;
	text-indent: 33px;
	line-height: 24px;
	height: 435px;
	overflow-y: scroll;
}

.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left {
	height: 50px;
	border: 1px solid #dcdcdc;
}

.mask .el-tabs--left.el-tabs--border-card .el-tabs__item.is-left.is-active {
	background-color: rgba(0, 0, 0, 0);
}

.el-tabs--left.el-tabs--border-card .el-tabs__header.is-left {
	border-right: 1px solid #dcdcdc;
}

.is-left .is-active {
	color: #d86556;
}

.mask .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active,
.el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
	background-color: #fff;
	color: #0e78c7 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Elasticframe/noticeCard.vue